// `BrandMark` — the brand-image primitive (currently the Aquarius
// Talent Promoter icon). Previously named `Badge`, but the introduction
// of `CountBadge` made the asymmetric naming sharp: a "badge" in
// common UI vocabulary is a small count / status indicator, not a
// brand image. Renamed to better reflect the semantic.

import { type ImgHTMLAttributes, useId } from 'react';

import { classlist } from '~/_shared/design-system/lib/classlist';

import './brand-mark.css';

type BrandMarkSize = 'sm' | 'md' | 'lg';

interface BrandMarkProps
	extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt' | 'size'> {
	src: string;
	alt: string;
	size?: BrandMarkSize;
}

const BrandMark = ({
	src,
	alt,
	size = 'md',
	id,
	className,
	...rest
}: BrandMarkProps) => {
	// Instance-unique default id (explicit `id` prop wins) — see BaseButton.
	const auto_id = useId();
	return (
		<img
			{...rest}
			id={id ?? `BrandMark-${auto_id}`}
			src={src}
			alt={alt}
			className={classlist('brand-mark', `brand-mark--${size}`, className)}
		/>
	);
};

export type { BrandMarkProps, BrandMarkSize };
export { BrandMark };
